// extracted by mini-css-extract-plugin
export default {"name":"cp_jZ","price":"cp_j4","items":"cp_j5","hidden":"cp_j6","item":"cp_ft","check":"cp_j7","toggleButton":"cp_j8","arrowIcon":"cp_gH","isOpen":"cp_j9"};